import {doctorTypes} from "../types/doctorTypes";

const initState = {
    doctors: [],
    doctorsListIsLoading: true,
    fetchingPage: false,
    currentPage: 1,
    lastPage: null,
    total: null,

    doctorReviews: [],
    reviewsLoading: false,
    noMoreReviews: false,

    featuredDoctors: [],
    featuredDoctorsListIsLoading: true,

    current: null,
    currentDoctorIsLoading: true,
    currentDoctorNotFound: false,


    branches: [],
    branchesIsLoading: true,


    currentBranch: null,
    currentBranchDays: [],
    currentBranchDaysLimit: 0,
    currentBranchDaysIsLoading: true,
    currentBranchDayTimes: [],
    currentBranchDayTimesLimit: 0,
    currentBranchDayTimesIsLoading: true,
    currentBranchDayBreaks: [],
    currentBranchDayBreaksIsLoading: true,


    currentBookingFees: null,
    currentBookingFeesIsLoading: true,
    currentBookingErrors: null,

    cities: [],
    citiesIsLoading: true,


    currentSearchData: null,

    goToDoctorProfileFromBooking: false,

    searchFromFooter: false,

};

const doctorReducer = (state = initState, action) => {
    switch (action.type) {
        case doctorTypes.GET_DOCTORS_LIST:
            state = {
                ...state,
                featuredDoctors: action.payload,
                featuredDoctorsListIsLoading: false
            };
            break;
        case doctorTypes.REQUEST_DOCTORS_PAGE:
            state = {
                ...state,
                doctors: [...state.doctors, ...action.payload.data],
                currentPage: action.payload.current_page,
                lastPage: action.payload.last_page,
                total: action.payload.total,
                doctorsListIsLoading: false
            };
            break;


        case doctorTypes.FETCHING_MORE_DOCTORS_PAGE:
            state = {
                ...state,
                fetchingPage: action.payload
            };
            break;
        case doctorTypes.REQUEST_AUTH_FOLLOWED_DOCTORS_PAGE:
            state = {
                ...state,
                doctors: [...state.doctors, ...action.payload.data],
                currentPage: action.payload.current_page,
                lastPage: action.payload.last_page,
                total: action.payload.total,
                doctorsListIsLoading: false
            };
            break;
        case doctorTypes.FETCHING_MORE_FOLLOWED_DOCTORS_PAGE:
            state = {
                ...state,
                fetchingPage: action.payload
            };
            break;
        case doctorTypes.GET_DOCTOR_DETAILS:
            state = {
                ...state,
                currentDoctorIsLoading: false,
                current: action.payload,
            };
            break;
        case doctorTypes.CURRENT_DOCTOR_NOT_FOUND:
            state = {
                ...state,
                currentDoctorNotFound: action.payload,
            };
            break;


        case doctorTypes.GET_DOCTOR_BRANCHES:
            state = {
                ...state,
                branches: action.payload,
                branchesIsLoading: false,
            };
            break;

        case doctorTypes.GET_BRANCH_DAYS:
            state = {
                ...state,
                currentBranch: action.payload.currentBranch,
                currentBranchDays: action.payload.days,
                currentBranchDaysIsLoading: false,
                currentBranchDaysLimit: action.payload.days.length
            };
            break;

        case doctorTypes.GET_BRANCH_DAY_TIMES:
            state = {
                ...state,
                currentBranchDayTimes: action.payload,
                currentBranchDayTimesIsLoading: false,
                currentBranchDayTimesLimit: action.payload.length
            };
            break;


        case doctorTypes.GET_BRANCH_DAY_BREAKS:
            state = {
                ...state,
                currentBranchDayBreaks: action.payload,
                currentBranchDayBreaksIsLoading: false,
            };
            break;

        case doctorTypes.GET_CURRENT_BOOKING_FEES_DETAILS:
            state = {
                ...state,
                currentBookingFees: action.payload,
                currentBookingFeesIsLoading: false,
            };
            break;

        case doctorTypes.GET_CURRENT_BOOKING_ERROR:
            state = {
                ...state,
                currentBookingErrors: action.payload,
                //currentBookingFeesIsLoading: false,
            };
            break;
        case doctorTypes.GET_DOCTOR_REVIEWS:
            state = {
                ...state,
                doctorReviews: [...state.doctorReviews, ...action.payload],
                doctorReviewsIsLoading: false,
            };
            break;
        case doctorTypes.CLEAR_REVIEWS :
            state = {
                ...state,
                doctorReviews: [],
                doctorReviewsIsLoading: false,
            };
            break;
        case doctorTypes.FETCHING_MORE_REVIEWS:
            state = {
                ...state,
                reviewsLoading: action.payload,
            };
            break;
        case doctorTypes.NO_MORE_REVIEWS :
            state = {
                ...state,
                noMoreReviews: action.payload,
            };
            break;
        case doctorTypes.CLEAR_DOCTOR_LIST:
            state = {
                ...state,
                doctors: [],
                doctorsListIsLoading: true,
                fetchingPage: false,
                currentPage: 1,
                lastPage: null,
                total: null,
                currentDoctorNotFound: false,
                branches: [],
                branchesIsLoading: true,
            };
            break;


        case doctorTypes.CLEAR_CURRENT_DOCTOR:
            state = {
                ...state,
                current: action.payload,
                currentDoctorIsLoading: true,
            };
            break;

        case doctorTypes.CLEAR_CURRENT_BRANCH:
            state = {
                ...state,

                currentBranch: null,
                currentBranchDays: [],
                currentBranchDaysIsLoading: true,
                currentBranchDayTimes: [],
                currentBranchDayTimesIsLoading: true,
                currentBranchDayBreaks: [],
                currentBranchDayBreaksIsLoading: true,
            };
            break;


        case doctorTypes.CLEAR_BOOKING_INFO:
            state = {
                ...state,
                currentBranch: null,
                currentBranchDays: [],
                currentBranchDaysLimit: 0,
                currentBranchDaysIsLoading: true,
                currentBranchDayTimes: [],
                currentBranchDayTimesLimit: 0,
                currentBranchDayTimesIsLoading: true,
                currentBranchDayBreaks: [],
                currentBranchDayBreaksIsLoading: true,
                currentBookingFees: null,
                currentBookingFeesIsLoading: true,
            };
            break;

        case doctorTypes.CLEAR_CURRENT_DAY:
            state = {
                ...state,
                currentBranchDayTimes: [],
                currentBranchDayTimesIsLoading: true,
                currentBranchDayBreaks: [],
                currentBranchDayBreaksIsLoading: true,
            };
            break;
        case doctorTypes.SEARCH_FOR_DOCTOR:
            state = {
                ...state,
                doctors: action.payload.data,
                doctorsListIsLoading: false,
                fetchingPage: false,
                currentPage: action.payload.current_page,
                lastPage: action.payload.last_page,
                total: action.payload.total,
                currentDoctorNotFound: false,
            };
            break;
        case doctorTypes.GET_CITIES_LIST:
            state = {
                ...state,
                cities: action.payload,
                citiesIsLoading: false,
            };
            break;

        case doctorTypes.SET_SEARCH_DATA:
            state = {
                ...state,
                currentSearchData: action.payload
            };
            break;

        case doctorTypes.GET_SEARCH_DATA:
            state = {
                ...state,
                currentSearchData: action.payload
            };
            break;

        case doctorTypes.CLEAR_SEARCH_DATA:
            state = {
                ...state,
                currentSearchData: null
            };
            break;

        case doctorTypes.GO_TO_DOCTOR_PROFILE_FROM_BOOKING:
            state = {
                ...state,
                goToDoctorProfileFromBooking: action.payload
            };
            break;
        // case doctorTypes.CLEAR_GO_TO_DOCTOR_PROFILE_FROM_BOOKING:
        //     state = {
        //         ...state,
        //         goToDoctorProfileFromBooking: action.payload
        //     };
        //     break;
        case doctorTypes.SEARCH_FROM_FOOTER:
            state = {
                ...state,
                searchFromFooter: action.payload
            };
            break;
        default :
        // do nothing
    }
    return state
};


export default doctorReducer